export const ADMIN_ACCESS_LEVEL = "Admin";
export const MAX_NON_ADMIN_USERS = 60;
export const USERS_PAGE_SIZE = 6;
export const ALL_DASHBOARDS_VALUE = "all";
export const SOCIAL_LISTENING_FEATURE = "social listening agent";
